import { render, staticRenderFns } from "./DamagesTab.vue?vue&type=template&id=4c776936&"
import script from "./DamagesTab.vue?vue&type=script&lang=js&"
export * from "./DamagesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports